export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_ENV === 'production'
    ? process.env.REACT_APP_GO_SSO_CLIENT_PRODUCTION
    : process.env.REACT_APP_GO_SSO_CLIENT_STAGING;

export const DESKTOP_GOOGLE_REDIRECT =
  process.env.REACT_APP_ENV === 'production'
    ? process.env.REACT_APP_DESKTOP_GO_REDIRECT_URI_PROD
    : process.env.REACT_APP_DESKTOP_GO_REDIRECT_URI_STAGING;

export const DASHBOARD_BASE_URL =
  process.env.REACT_APP_ENV === 'production'
    ? process.env.REACT_APP_DASHBOARD_URL_PROD
    : process.env.REACT_APP_DASHBOARD_URL_STAGING;

export const MICROSOFT_CLIENT_ID =
  process.env.REACT_APP_ENV === 'production'
    ? process.env.REACT_APP_MS_SSO_CLIENT_PRODUCTION
    : process.env.REACT_APP_MS_SSO_CLIENT_STAGING;

export const MICROSOFT_TENTANT_ID =
  process.env.REACT_APP_ENV === 'production'
    ? process.env.REACT_APP_MS_TENANT_STAGING
    : process.env.REACT_APP_MS_TENANT_STAGING;

export const APPLE_CLIENT_ID = 'com.salesstack.dashboard';
// process.env.REACT_APP_ENV === 'production'
//   ? process.env.REACT_APP_AP_SSO_CLIENT_PRODUCTION
//   : process.env.REACT_APP_AP_SSO_CLIENT_STAGING;

export const MS_REDIRECT_URI =
  process.env.REACT_APP_ENV === 'production' ? process.env.MS_REDIRECT_URI_PROD : process.env.MS_REDIRECT_URI_STAGING;

const MICROSOFT_SSO_URL = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize';

const CLIENT_ID = '71f68bdc-ecdd-4acc-8906-94a9cd57f5b0';
const SCOPE = 'User.Read openid profile offline_access';
const REDIRECT_URI = 'https://sales-internal-dashboard-0077.holofy.io/sales-stack/login';
const CLIENT_REQUEST_ID = '08d24a3e-5e53-4ad8-98ed-b587b7e261b7';
const RESPONSE_MODE = 'fragment';
const RESPONSE_TYPE = 'code';
const X_CLIENT_SKU = 'msal.js.browser';
const X_CLIENT_VER = '3.6.0';
const CLIENT_INFO = '1';
const CODE_CHALLENGE = 'Xz2yKcrLF2QGHCWBoLhonV5Fyty00CDGgQQmbD_Ri90';
const CODE_CHALLENGE_METHOD = 'S256';
const NONCE = 'c93bf084-b141-4c48-a37b-c12fcda87ff5';
const STATE =
  'eyJpZCI6IjFiYmI1ZjZhLTA0MTktNDBiZC05MjIwLTUzMTI4NTQxNjE5ZSIsIm1ldGEiOnsiaW50ZXJhY3Rpb25UeXBlIjoicmVkaXJlY3QifX0%3D';

export const constructMicrosoftSSOUrl = () => {
  const urlParams = new URLSearchParams({
    client_id: CLIENT_ID,
    scope: SCOPE,
    redirect_uri: REDIRECT_URI,
    'client-request-id': CLIENT_REQUEST_ID,
    response_mode: RESPONSE_MODE,
    response_type: RESPONSE_TYPE,
    'x-client-SKU': X_CLIENT_SKU,
    'x-client-VER': X_CLIENT_VER,
    client_info: CLIENT_INFO,
    code_challenge: CODE_CHALLENGE,
    code_challenge_method: CODE_CHALLENGE_METHOD,
    nonce: NONCE,
    state: STATE,
  });

  return `${MICROSOFT_SSO_URL}?${urlParams.toString()}`;
};
